import { render, staticRenderFns } from "./goodsBatchTrace.vue?vue&type=template&id=0a133c72&scoped=true"
import script from "./goodsBatchTrace.vue?vue&type=script&lang=js"
export * from "./goodsBatchTrace.vue?vue&type=script&lang=js"
import style0 from "./goodsBatchTrace.vue?vue&type=style&index=0&id=0a133c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a133c72",
  null
  
)

export default component.exports